function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-144 -141)"
}, React.createElement("g", {
  transform: "translate(144 141)"
}, React.createElement("path", {
  d: "M156.785,141H146.2a2.218,2.218,0,0,0-2.2,2.274V154.2a2.237,2.237,0,0,0,2.2,2.3h10.581A2.246,2.246,0,0,0,159,154.2V143.274A2.227,2.227,0,0,0,156.785,141Zm.942,13.2a.955.955,0,0,1-.942.951H146.2a.946.946,0,0,1-.93-.951V143.274a.927.927,0,0,1,.93-.93h10.581a.936.936,0,0,1,.942.93Z",
  transform: "translate(-144 -141)",
  fill: "#949db2"
}), React.createElement("path", {
  d: "M229.711,219H224.8a.637.637,0,1,0,0,1.274h4.913a.637.637,0,1,0,0-1.274Z",
  transform: "translate(-218.47 -213.481)",
  fill: "#949db2"
}), React.createElement("ellipse", {
  cx: 0.658,
  cy: 0.679,
  rx: 0.658,
  ry: 0.679,
  transform: "translate(3.226 5.479)",
  fill: "#949db2"
}), React.createElement("path", {
  d: "M229.711,256H224.8a.672.672,0,0,0,0,1.344h4.913a.672.672,0,0,0,0-1.344Z",
  transform: "translate(-218.47 -247.863)",
  fill: "#949db2"
}), React.createElement("ellipse", {
  cx: 0.658,
  cy: 0.679,
  rx: 0.658,
  ry: 0.679,
  transform: "translate(3.226 8.151)",
  fill: "#949db2"
}), React.createElement("path", {
  d: "M229.711,294H224.8a.672.672,0,0,0,0,1.344h4.913a.672.672,0,0,0,0-1.344Z",
  transform: "translate(-218.47 -283.175)",
  fill: "#949db2"
}), React.createElement("ellipse", {
  cx: 0.658,
  cy: 0.679,
  rx: 0.658,
  ry: 0.679,
  transform: "translate(3.226 10.824)",
  fill: "#949db2"
}), React.createElement("path", {
  d: "M193.805,181h-7.647a.672.672,0,0,0,0,1.344h7.647a.672.672,0,0,0,0-1.344Z",
  transform: "translate(-182.564 -178.17)",
  fill: "#949db2"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15.495,
    viewBox: "0 0 15 15.495"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/purchase-order.b339c7de.svg";
export { SvgComponent as ReactComponent };